import api, { setToken } from '../index';

export function programs(data) {
	return api.get('/courses', setToken(data));
}

export function courseProgram(data) {
	return api.get(`/courses/${data.programId}`, setToken(data.token));
}

export function sendLessonVideo(data) {
	const body = data.part ? { part: data.part } : {};
	return api.post(`/courses/lesson-video/${data.eventId}/send`, body, setToken(data.token));
}

export function checkLessonVideo(data) {
	return api.post(`/courses/lesson-video/${data.eventId}/send`, { check: 1 }, setToken(data.token));
}
